import { Typography } from '@mui/material'
import { COLORS } from '../../../styles/variables'

export type DecisionStatus = 'accepted' | 'declined' | 'approved' | 'rejected' | (string & {})

const POSITIVE_STATUSES = new Set<string>(['accepted', 'approved'])
const NEGATIVE_STATUSES = new Set<string>(['declined', 'rejected'])

const DECISION_STATUS_LABELS: Record<string, string> = {
  accepted: 'принято',
  declined: 'отклонено',
  approved: 'одобрена',
  rejected: 'отклонена',
}

function decisionStatusColor(status: string): string {
  if (POSITIVE_STATUSES.has(status)) return COLORS.NOTIFICATION_STATUS_POSITIVE
  if (NEGATIVE_STATUSES.has(status)) return COLORS.NOTIFICATION_STATUS_NEGATIVE
  return COLORS.CHARCOAL_GREY
}

type Props = {
  status: DecisionStatus
}

export function NotificationDecisionStatus({ status }: Props) {
  const label = DECISION_STATUS_LABELS[status] ?? status

  return (
    <Typography
      component="span"
      variant="black-14-medium"
      sx={{ color: decisionStatusColor(status), flexShrink: 0 }}
    >
      {label}
    </Typography>
  )
}
